import React, { useEffect } from 'react'
import { ReactLenis } from 'lenis/react'

import styles from './HomeNew.module.scss'
import Button from 'components/Button'
import images from 'assets/images'
import Marquee from 'react-fast-marquee'
import DropdownSearch from 'components/DropdownSearch'
import { arrChain, arrDex, arrDex2, arrToken } from './constant'
import useResizeWidth from 'controller/useResizeWidth'
import { toFormatted } from 'commons/function'

const arrStatus = [
  {
    title: 'Next-Level Accessibility',
    content: [
      {
        title: 'Fast & Safe',
        infoTitle: 'TRANSACTIONS',
        infoInformation: 'transaction',
        icon: 'icon-ic-move',
      },
      {
        title: 'Global & Growing',
        infoTitle: 'ACCOUNTS',
        infoInformation: 'accounts',
        icon: 'icon-ic-user',
      },
      {
        title: 'Affordable & Efficient',
        textLink: 'Learn how we achieve zero gas fees',
        link: 'https://blog.viction.xyz/all-about-zero-gas-fee-on-viction/',
        isBlank: true,
        infoTitle: 'GAS FEE',
        infoInformation: 'gas',
        icon: 'icon-ic-usd',
      },
    ],
  },
  {
    title: 'Enhanced Security',
    content: [
      {
        title: 'Governed by you with Proof-of-Stake Voting',
        textLink: 'Learn more',
        infoTitle: 'MASTERNODES',
        infoInformation: 'information',
        link: '/masternode',
        // icon: 'icon-ic-move',
        img: images.iconMasternode,
      },
    ],
  },
]

const arrRealLive = [
  {
    title: 'DeFi Hub',
    detailTitle: 'Earn compound interest',
    description:
      'Viction makes Web3 accessible, offering staking, farming, and launchpads. Start with just a penny and grow into potential millions.',
    img: images.defiHub,
  },
  {
    title: 'Game Powerhouse',
    detailTitle: 'Play with merits',
    description:
      'Viction enhances the gaming experience, allowing users to play, own, and earn (rewards and loyalty) through quality gameplay and assets (NFTs, tokens).',
    img: images.gamePower,
  },
  {
    title: 'NFT Fandom',
    detailTitle: 'Own with pride',
    description:
      'Viction NFTs celebrate creativity, preserving artistic value and culture while ensuring long-term significance and ownership.',
    img: images.nftFandom,
  },
  {
    title: 'Global Payment Highway',
    detailTitle: 'Transfer without limits',
    description:
      'Viction breaks time and cost barriers, enabling instant, low-cost cross-border transfers through stablecoins and global exchange listings.',
    img: images.globalPayment,
  },
]

const ecoLogo1 = [
  images.eco1,
  images.eco2,
  images.eco3,
  images.eco4,
  images.eco5,
  images.eco6,
  images.eco7,
  images.eco8,
  images.eco9,
  images.eco10,
  images.eco11,
  images.eco12,
  images.eco13,
]

const ecoLogo2 = [
  images.eco14,
  images.eco15,
  images.eco16,
  images.eco17,
  images.eco18,
  images.eco19,
  images.eco20,
  images.eco21,
  images.eco22,
  images.eco23,
  images.eco24,
  images.eco25,
]

const arrCommunity = [
  images.community3,
  images.community2,
  images.community1,
  images.community4,
  images.community5,
]

const arrCountry = [
  {
    name: 'Africa',
    flag: images.flag6,
  },
  {
    name: 'Thailand',
    flag: images.flag2,
  },
  {
    name: 'Turkey',
    flag: images.flag3,
  },
  {
    name: 'Indonesia',
    flag: images.flag4,
  },
  {
    name: 'Philippines',
    flag: images.flag7,
  },
  {
    name: 'Korea',
    flag: images.flag5,
  },
  {
    name: 'VietNam',
    flag: images.flag1,
  },
  {
    name: 'And beyond!',
    icon: 'icon-icon-up',
  },
]

function HomeNew() {
  const { positionY, widthResize, isScrollDown } = useResizeWidth()
  const isTabletSmall = widthResize <= 768

  const imgBannerRef = React.useRef(null)
  const ourRef = React.useRef([null])
  const journeyBannerRef = React.useRef(null)
  const journeyRef = React.useRef(null)

  const journeyPosition = journeyBannerRef.current
    ? journeyBannerRef.current.offsetTop + journeyBannerRef.current.offsetHeight
    : 0
  const ourHeight = ourRef.current ? ourRef.current.offsetTop + 1100 : 0

  const imgSmall = positionY >= ourHeight
  const journeyShow = positionY >= journeyPosition

  const imgBannerHeight = imgBannerRef.current
    ? imgBannerRef.current.offsetTop
    : 0
  const imgBannerChange = positionY >= imgBannerHeight - 200

  const [itemChoose, setItemChoose] = React.useState({
    token: null,
    chain: null,
  })
  const [dataStatus, setDataStatus] = React.useState({
    transaction: 0,
    accounts: 0,
    gas: '$0.0001',
    information: 150,
  })
  const [scrollToJourney, setScrollToJourney] = React.useState(false)

  const fetchData = async () => {
    try {
      const response = await fetch('https://www.vicscan.xyz/api/stats')
      const result = await response.json()
      setDataStatus({
        ...dataStatus,
        transaction: toFormatted(result.txs, false, 0),
        accounts: toFormatted(result.accounts, false, 0),
      })

      console.log({ result })
    } catch (error) {
      console.log({ error })
    }
  }

  const onChooseItem = (status) => (item) => {
    setItemChoose((prev) => ({
      ...prev,
      [status]: item,
    }))
  }

  useEffect(() => {
    if (imgBannerChange && isScrollDown && !scrollToJourney) {
      imgBannerRef.current && imgBannerRef.current.scrollIntoView()
    } else {
      return
    }
  }, [imgBannerChange, isScrollDown, scrollToJourney])

  useEffect(() => {
    fetchData()
  }, [])

  return (
    // <ReactLenis root>
    <div className={styles.homeNewWrapper}>
      <div className='home-container'>
        <div className='banner-wrapper'>
          <div className='banner-container'>
            <h1 className='banner-title'>
              Ownership {isTabletSmall && <br />} Economy for All
            </h1>

            <div className='banner-description'>
              In Viction, you own what matters
            </div>

            <div className='btn-action'>
              <a
                href='https://docs.viction.xyz/'
                target='_blank'
                rel='noopener noreferrer'>
                <Button>
                  Build on Viction{' '}
                  <span className='icon-web_arrow_up_right arrow-up-right'></span>
                </Button>
              </a>
              <Button
                variant='secondary'
                onClick={() => {
                  journeyBannerRef.current.scrollIntoView()
                  setScrollToJourney(true)
                  setTimeout(() => {
                    setScrollToJourney(false)
                  }, 2000)
                }}>
                Get Started{' '}
                <span className='icon-web_arrow_up_right arrow-up-right'></span>
              </Button>
            </div>
          </div>
        </div>

        <div className='img-wrapper' ref={imgBannerRef}>
          <img
            src={images.curveWhiteUp}
            alt='curve white up'
            className={`img-curve ${imgBannerChange && 'img-curve--change'}`}
          />

          <img
            src={images.bgBanner1}
            alt='Banner Background'
            className={`img-banner-background img-banner-background--background-1 ${
              imgBannerChange && 'img-banner-background--background-1--change'
            }`}
          />
          <img
            src={images.bgBanner2}
            alt='Banner Background'
            className='img-banner-background img-banner-background--background-2'
          />
        </div>

        <div className='content-body'>
          <div className='status-wrapper'>
            <div className='status-container'>
              {arrStatus.map((item, index) => {
                return (
                  <div className='status-item' key={index}>
                    <div className='status-title'>
                      <h3>{item.title}</h3>
                    </div>

                    <div className='status-content'>
                      {item.content.map((itemContent, indexContent) => {
                        return (
                          <div className='content-item' key={indexContent}>
                            <div className='content-title'>
                              <div className='text-title'>
                                {itemContent.title}
                              </div>

                              {itemContent.textLink && (
                                <div className='text-link text-hover-underline'>
                                  <a
                                    href={itemContent.link}
                                    target={
                                      itemContent.isBlank ? '_blank' : '_self'
                                    }
                                    rel='noopener noreferrer nofollow'>
                                    {itemContent.textLink}
                                  </a>
                                </div>
                              )}
                            </div>

                            <div className='content-info'>
                              <div className='info-text'>
                                <div className='info-title'>
                                  {itemContent.infoTitle}
                                </div>

                                <div className='info-information'>
                                  {dataStatus[itemContent.infoInformation]}
                                </div>
                              </div>

                              <div className='content-icon'>
                                {itemContent.icon ? (
                                  <span className={itemContent.icon}></span>
                                ) : (
                                  <img
                                    src={itemContent.img}
                                    alt='icon'
                                    className='img-icon'
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className='real-live'>
            <div className='real-live-container'>
              <div className='real-live-title'>
                <div className='title-live'>
                  We infuse blockchain Into real-life moments
                </div>

                <div className='description-live'>
                  Viction constructs the next billion users' ownership economy
                  by tapping into the micro-moments of how we pay, play, invest,
                  and own.
                </div>
              </div>

              <div className='real-live-content'>
                {arrRealLive.map((item, index) => {
                  return (
                    <div
                      className={`content-live content-live--live-${index + 1}`}
                      key={index}>
                      <div className='live-content-text'>
                        <div className='live-title'>
                          <div className='title-number'>0{index + 1}</div>
                          <div className='title-text'>{item.title}</div>
                        </div>

                        <div className='live-detail-text'>
                          <div className='detail-title'>{item.detailTitle}</div>
                          {item.description}
                        </div>
                      </div>

                      <div className='live-content-img'>
                        <img
                          src={item.img}
                          alt='DeFi Hub'
                          className='img-live'
                        />
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            <div className='button-live'>
              <a
                href='https://docs.viction.xyz/'
                target='_blank'
                rel='noopener noreferrer nofollow'>
                <Button>
                  Build on Viction{' '}
                  <span className='icon-web_arrow_up_right'></span>
                </Button>
              </a>
            </div>

            <img
              src={images.curveBlack}
              alt='curve white down'
              className='curve-black'
            />
          </div>

          <div className='ecosystem'>
            <div className='ecosystem-container'>
              <div className='ecosystem-title'>
                <div className='title-ecosystem'>
                  Discover The Ecosystem Driving The Ownership Economy
                </div>
                <div className='title-description-ecosystem'>
                  The Viction ecosystem keeps expanding and now includes
                  hundreds of live projects.
                </div>
              </div>

              <div className='ecosystem-logo'>
                <Marquee className='marquee-logo'>
                  {ecoLogo1.map((item, index) => {
                    return (
                      <div className='item-logo' key={index}>
                        <div className='logo'>
                          <img
                            src={item}
                            alt='ecosystem logo'
                            className='img-eco-logo'
                          />
                        </div>
                      </div>
                    )
                  })}
                </Marquee>
                <Marquee direction='right'>
                  {ecoLogo2.map((item, index) => {
                    return (
                      <div className='item-logo' key={index}>
                        <div className='logo'>
                          <img
                            src={item}
                            alt='ecosystem logo'
                            className='img-eco-logo'
                          />
                        </div>
                      </div>
                    )
                  })}
                </Marquee>
              </div>

              <div className='button-action'>
                <a href='/ecosystem'>
                  <Button variant='secondary'>
                    See All Projects{' '}
                    <span className='icon-web_arrow_up_right'></span>
                  </Button>
                </a>
              </div>
            </div>
          </div>

          <div className='journey' ref={journeyRef}>
            <div className='journey-container'>
              <div className='journey-banner' ref={journeyBannerRef}>
                <div className='title-journey-text'>
                  Start Your Journey With
                </div>

                <div className='title-journey-des'>$VIC</div>

                <div className='img-banner'>
                  <div className='img-token'>
                    <img
                      src={images.tokenVic}
                      alt='Token VIC'
                      className={`img-token-vic ${
                        journeyShow && 'img-token-vic--move'
                      }`}
                    />

                    <img
                      src={images.circleNew1}
                      alt='Circle New 1'
                      className={`img-circle img-circle--new-1 ${
                        journeyShow && 'img-circle--new-1--move'
                      }`}
                    />
                    <img
                      src={images.circleNew2}
                      alt='Circle New 2'
                      className={`img-circle img-circle--new-2 ${
                        journeyShow && 'img-circle--new-2--move'
                      }`}
                    />
                    <img
                      src={images.circleNew3}
                      alt='Circle New 3'
                      className={`img-circle img-circle--new-3 ${
                        journeyShow && 'img-circle--new-3--move'
                      }`}
                    />
                    <img
                      src={images.circleNew4}
                      alt='Circle New 4'
                      className={`img-circle img-circle--new-4 ${
                        journeyShow && 'img-circle--new-4--move'
                      }`}
                    />
                  </div>

                  <div className='img-token img-token--token-2'>
                    <img
                      src={images.tokenVic}
                      alt='Token VIC'
                      className={`img-token-vic ${
                        journeyShow && 'img-token-vic--move'
                      }`}
                    />

                    <img
                      src={images.circleNew1}
                      alt='Circle New 1'
                      className={`img-circle img-circle--new-1 ${
                        journeyShow && 'img-circle--new-1--move'
                      }`}
                    />
                    <img
                      src={images.circleNew2}
                      alt='Circle New 2'
                      className={`img-circle img-circle--new-2 ${
                        journeyShow && 'img-circle--new-2--move'
                      }`}
                    />
                    <img
                      src={images.circleNew3}
                      alt='Circle New 3'
                      className={`img-circle img-circle--new-3 ${
                        journeyShow && 'img-circle--new-3--move'
                      }`}
                    />
                    <img
                      src={images.circleNew4}
                      alt='Circle New 4'
                      className={`img-circle img-circle--new-4 ${
                        journeyShow && 'img-circle--new-4--move'
                      }`}
                    />
                  </div>

                  <img
                    src={images.user1}
                    alt=''
                    className={`img-user img-user--user-1 ${
                      journeyShow && 'img-user--user-1--move'
                    }`}
                  />
                  <img
                    src={images.user2}
                    alt=''
                    className={`img-user img-user--user-2 ${
                      journeyShow && 'img-user--user-2--move'
                    }`}
                  />
                </div>
              </div>

              <div className='journey-content'>
                <div className='journey-info'>
                  <div className='info-description'>
                    As the lifeblood of our ownership economy, $VIC gives
                    everyone the power to vote on what gets built, stake to earn
                    while securing the network, and engage in diverse activities
                    across the Viction ecosystem.
                  </div>

                  <div className='btn-action'>
                    <a
                      href='https://1198941402-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FPmPMaOPJdK9KcdXtJdQH%2Fuploads%2FZUMv9nKNTKxJS8MlRULO%2FVICTION%20Economics%20Paper%202.0.pdf?alt=media&token=e9480ae4-4a67-4c1f-8fb4-acd529607746'
                      target='_blank'
                      rel='noopener noreferrer'>
                      <Button className='btn-custom'>
                        Learn about Viction Tokenomics{' '}
                        <span className='icon-web_arrow_up_right'></span>
                      </Button>
                    </a>
                  </div>
                </div>

                <div className='journey-content-body'>
                  <div className='content-body-title'>
                    3 Easy Ways To Get <span>$VIC</span>
                  </div>

                  <div className='content-body-detail'>
                    <div className='item-detail'>
                      <div className='item-detail-title'>
                        <div className='title-text'>
                          “I don't have VIC or Any Tokens on Viction”
                        </div>

                        <div className='box-arrow'>
                          <span className='icon-web_arrow_right arrow-icon'></span>
                        </div>
                      </div>

                      <div className='item-detail-choose'>
                        <div className='item-choose'>
                          <div className='item-choose__title'>
                            Buy $VIC on Centralized Exchanges
                          </div>

                          <DropdownSearch
                            arrData={arrDex}
                            placeholder='Select Exchange'
                          />
                        </div>

                        <div className='line-middle'>
                          <div className='line'></div>
                          or
                          <div className='line'></div>
                        </div>

                        <div className='item-choose'>
                          <div className='item-choose__title'>
                            {/* Swap Tokens for $VIC from Other Chains */}
                            Get $VIC from Onramp providers
                          </div>

                          <DropdownSearch
                            arrData={arrDex2}
                            placeholder='Select Swap'
                          />
                        </div>
                      </div>
                    </div>

                    <div className='item-detail'>
                      <div className='item-detail-title item-detail-title--title-full'>
                        <div className='title-text'>
                          “I have Tokens on Viction”
                        </div>

                        <div className='box-arrow'>
                          <span className='icon-web_arrow_right arrow-icon'></span>
                        </div>
                      </div>

                      <div className='item-detail-choose'>
                        <div className='item-choose'>
                          <div className='item-choose__title'>
                            Swap tokens for VIC on Viction
                          </div>

                          <DropdownSearch
                            arrData={arrToken}
                            placeholder='Select Token'
                            onChoose={onChooseItem('token')}
                          />
                        </div>

                        {/* <div className='line-middle'>
                          <div className='line'></div>
                          or
                          <div className='line'></div>
                        </div> */}

                        {itemChoose.token && (
                          <div className='item-choose'>
                            <div className='item-choose__title item-choose__title--normal'>
                              You can swap your{' '}
                              <span>{itemChoose.token.name}</span> for $VIC via
                            </div>

                            {/* <DropdownSearch arrData={arrDex2} /> */}
                            <div className='button-link'>
                              <a
                                href='https://rabbitswap.xyz/swap'
                                target='_blank'
                                rel='noopener noreferrer nofollow'>
                                <div className='link-content'>
                                  <img
                                    src={images.vicLogoRabbit}
                                    alt='logo rabbit'
                                    className='img-logo'
                                  />
                                  Rabbit Swap
                                </div>
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='item-detail item-detail--last'>
                      <div className='item-detail-title item-detail-title--title-full'>
                        <div className='title-text'>
                          “I have Tokens on Another Chain”
                          <div className='title-description'>
                            Ethereum, Arbitrum One, BNB Smart Chain, Solana
                          </div>
                        </div>

                        <div className='box-arrow'>
                          <span className='icon-web_arrow_right arrow-icon'></span>
                        </div>
                      </div>

                      <div className='item-detail-choose'>
                        <div className='item-choose'>
                          <div className='item-choose__title'>
                            Transfer Tokens from Other Chains to Viction
                          </div>

                          <DropdownSearch
                            arrData={arrChain}
                            placeholder='Select Chain'
                            onChoose={onChooseItem('chain')}
                          />
                        </div>

                        {/* <div className='line-middle'>
                          <div className='line'></div>
                          or
                          <div className='line'></div>
                        </div> */}

                        {itemChoose.chain && (
                          <div className='item-choose'>
                            <div className='item-choose__title item-choose__title--normal'>
                              You can bridge your token from{' '}
                              <span>{itemChoose.chain.name}</span> to Viction
                              via
                            </div>

                            <DropdownSearch
                              arrData={itemChoose.chain.dex}
                              placeholder='Select Bridge'
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='journey-description'>
                  * Disclaimer: All tools interacting with assets are provided
                  by partners of Viction and are not directly operated by us.
                  Please always double-check the status of the tool and test
                  with a small amount before performing large transactions to
                  avoid potential loss.
                </div>
              </div>
            </div>
          </div>

          <div className='our-community' ref={ourRef}>
            <div className='our-community-container'>
              <div className='our-banner'>
                <div className='our-logo'>
                  <img src={images.logoFrontier} alt='' className='logo-our' />
                </div>

                <div className='our-title'>Our Community Growth Engine</div>

                <div className='our-slide-wrapper'>
                  <div className='our-slide'>
                    {arrCommunity.map((item, i) => {
                      const imgMiddle = i === 2

                      return (
                        <div
                          className={`item-img item-img--img-${i + 1} ${
                            imgMiddle && imgSmall && 'item-img--img-3--small'
                          }`}
                          key={i}>
                          <img
                            src={item}
                            alt='Community 1'
                            className='img-community'
                          />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>

              <div className='our-content'>
                <div className='our-content-title'>We're already active in</div>

                <div className='our-content-country'>
                  {arrCountry.map((item, index) => {
                    return (
                      <div className='country-item' key={index}>
                        {item.flag ? (
                          <img
                            src={item.flag}
                            alt=''
                            className='country-flag'
                          />
                        ) : (
                          <span className={`country-flag ${item.icon}`}></span>
                        )}
                        {item.name}
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className='our-btn'>
                <a
                  href='https://blog.frontierdao.org/frontierdao-viction-community-growth-engine-uyoo0tg81slg'
                  target='_blank'
                  rel='noopener noreferrer nofollow'>
                  <Button className='btn-custom' variant='secondary'>
                    Learn more about FrontierDAO{' '}
                    <span className='icon-web_arrow_up_right'></span>
                  </Button>
                </a>

                <a
                  href='https://frontier-dao.notion.site/viction-vanguard-3-0-all-in-one-hub-for-web3-creators'
                  target='_blank'
                  rel='noopener noreferrer nofollow'>
                  <Button className='btn-custom'>
                    Contribute to Viction Community{' '}
                    <span className='icon-web_arrow_up_right'></span>
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </ReactLenis>
  )
}

export default HomeNew
